import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-sticky-footer',
  templateUrl: './sticky-footer.component.html',
  styleUrls: ['./sticky-footer.component.scss']
})
export class StickyFooterComponent implements OnInit {
  public openModalPhone: boolean;

  @ViewChild('phone') menu: ElementRef;
  @ViewChild('phone2') menu2: ElementRef;

	@HostListener('document:mousedown', ['$event']) onGlobalClick(event): void {
    if (this.openModalPhone && event.target !== this.menu.nativeElement && event.target !== this.menu2.nativeElement) {
			this.openModalPhone = false;
		}
  }
  constructor() { }

  ngOnInit(): void {
  }

}
